export default function ConfigureUploadAssets(){
    return <></>
}